$(function(){
    $('.product__accordion.accordion').each(function () {
        if (!$(this).find('.metafield-rich_text_field, .metafield-multi_line_text_field').length) {
            $(this).css('display', 'none');
        }
    });


    $('.product__accordion.accordion summary').click(function(){
        if($(this).attr('aria-expanded') == 'true' ){
            $(this).find('.toggle_btn').addClass('on')
        }else{
            $(this).find('.toggle_btn').removeClass('on')
        }
    })
    
    if($('.result_content .how_to_use').length > 0){  
        $('.how_to_use > div').each(function() {
            const text = $(this).text().trim();
            const parts = text.split('.').map(s => s.trim()).filter(Boolean);
            const wrapped = parts.map(s => `<span class="htu">${s}</span>`).join('');
            $(this).html(wrapped);
        });

        $('.how_to_use').each(function() {
            $(this).find('.htu').each(function() {
                $(this).prepend('<i>Step 0'+($(this).index() + 1)+'</i>')
            });
        });
    }

    if($('.product_detail_visual:not(.set_detail_visual)').length > 0){
        const productNameVis = $('.product_detail_visual .product_name').text();
        const productNameVisLower = productNameVis.toLowerCase();
        const skuHyaluronic = "Hyaluronic";
        const skuSoap = "Soap Bar";
        const skuBdrn = "Banana PDRN";
        const skuScalp = "Scalp Serum";
        const skuCellulose = "Cellulose";
        const skuCollagen = "Hydro Collagen";
        const sku131serum = "Clearing Serum";
        const sku131cream = "Soothing Cream";
        const sku131toner = "Cooling Toner";
        const sku131cleanser = "BHA Cleanser";


        if(productNameVis.includes(skuHyaluronic)){
            $('.product_detail_visual .product_name').html(productNameVis.replace('Hyaluronic','Hyaluronic<br/>'));
        }else if(productNameVis.includes(skuSoap)){
            $('.product_detail_visual .product_name').html(productNameVis.replace('Soap Bar','<br/>Soap Bar'));        
        }else if(productNameVis.includes(skuBdrn)){
            $('.product_detail_visual .product_name').html(productNameVis.replace('Banana PDRN','Banana PDRN<br/>'));        
        }else if(productNameVis.includes(skuScalp)){
            $('.product_detail_visual .product_name').html(productNameVis.replace('Scalp Serum','<br/>Scalp Serum'));        
        }else if(productNameVis.includes(skuCellulose)){
            $('.product_detail_visual .product_name').html(productNameVis.replace('Cellulose','<br/>Cellulose'));        
        }else if(productNameVis.includes(skuCollagen)){
            $('.product_detail_visual .product_name').html(productNameVis.replace('Hydro Collagen','Hydro Collagen<br/>'));        
        }else if(productNameVis.includes(sku131serum)){
            $('.product_detail_visual .product_name').html(productNameVis.replace('Clearing Serum','<br/>Clearing Serum'));        
        }else if(productNameVis.includes(sku131cream)){
            $('.product_detail_visual .product_name').html(productNameVis.replace('Soothing Cream','<br/>Soothing Cream'));        
        }else if(productNameVis.includes(sku131toner)){
            $('.product_detail_visual .product_name').html(productNameVis.replace('Cooling Toner','<br/>Cooling Toner'));        
        }else if(productNameVis.includes(sku131cleanser)){
            $('.product_detail_visual .product_name').html(productNameVis.replace('BHA Cleanser','<br/>BHA Cleanser'));        
        }
    }

    if($('#new_product .product__title h1[rel="10045230350615"]').length > 0){
        $('.set_product_list > li:nth-of-type(3)').after('<li style="width:1px; padding:0;"></li>');    
    }

    document.addEventListener(
    'click',
    function (e) {
        const btn = e.target.closest('product-recommendations button[name="add"]');
        if (!btn) return;
        if (btn.hasAttribute('data-quick-add') || btn.closest('quick-add-modal')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        }
    },
    true 
    );


    document.addEventListener(
    'click',
    function (e) {
        const btn = e.target.closest('product-recommendations button[name="add"]');
        if (!btn) return;

        const card = btn.closest('[data-product-handle], [data-product-id]');
        if (!card) return;

        const handle = card.dataset.productHandle;

        if (!handle) return;

        fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(product => {
            if (product.variants.length === 1) {
            window.location.href = `/cart/add?id=${product.variants[0].id}`;
            return;
            }
            fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: product.variants[0].id,
                quantity: 1
            })
            }).then(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            });
        });
    },
    false
    );


})